import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from './alertMessageSlice';

import ExecutivePortalService from '../services/executivePortal.service';
import { getAllUserOf_A_Tenant } from './executivePortalTenantManagementSlice';

export const tenantAnalytics = createAsyncThunk(
  'tenantAnalytics',
  async (_, thunkAPI) => {
    try {
      const data = await ExecutivePortalService.tenantAnalytics();
      //   const data2 = await ExecutivePortalService.tenantManagementList();

      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const tenantTrendsList = createAsyncThunk(
  'tenantTrendsList',
  async (body, thunkAPI) => {
    try {
      const data = await ExecutivePortalService.tenantTrendsList(body);
      return data ;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const tenantManagementList = createAsyncThunk(
  'tenantManagementList',
  async (_, thunkAPI) => {
    try {
      const data = await ExecutivePortalService.tenantManagementList();
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const teamManagementList = createAsyncThunk(
  'teamManagementList',
  async (_, thunkAPI) => {
    try {
      const data = await ExecutivePortalService.teamManagementList();
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createTenant = createAsyncThunk(
  'createTenant',
  async (createTenantData, thunkAPI) => {
    try {
      await ExecutivePortalService.createTenant(createTenantData);
      const data = await ExecutivePortalService.tenantManagementList();
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deleteTenant = createAsyncThunk(
  'deleteTenant',
  async ({tenant_id,tenant_name}, thunkAPI) => {
    try {
      await ExecutivePortalService.deleteTenant(tenant_id);
      thunkAPI.dispatch(setMessage(`Tenant "${tenant_name}" deleted successfully`));
      const data = await ExecutivePortalService.tenantManagementList();
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const removeMobile = createAsyncThunk(
  'removeMobile',
  async ({tenant_id,user_id,reason}, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('user'));
      await ExecutivePortalService.removeMobile(tenant_id,user_id,reason,
                brandUser?.user_details.user_id,"brandastra admin");
      
      // thunkAPI.dispatch(setMessage(`Tenant "${tenant_name}" deleted successfully`));
      // const data = await ExecutivePortalService.tenantManagementList();
      const data = await thunkAPI.dispatch(getAllUserOf_A_Tenant(tenant_id));
      thunkAPI.dispatch(setMessage("Mobile Number Removed Successfully"));
      return { data };
    } catch (error) {
      console.log(error,"error");
      
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.message || error.response.data.detail)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createExecutive = createAsyncThunk(
  'createExecutive',
  async (body, thunkAPI) => {
    try {
      const updatedArray = body.map((element) => {
        const user_name = element.userName;
        const first_name = element.firstName;
        const last_name = element.lastName;
        const password = element.password;
        const email_id = element.email;
        const role_id = element.role === 'BrandAstra Support' ? 2 : 1;

        return {
          user_name,
          first_name,
          last_name,
          password,
          email_id,
          role_id,
        };
      });
      await ExecutivePortalService.createExecutive(updatedArray);
      const data = await ExecutivePortalService.teamManagementList();
      thunkAPI.dispatch(
        setMessage(
          `Successfully added new team members`
        )
      );
      return { data };
    } catch (error) {
      const message =
        (
          error.response &&
          error.response.data &&
          ((error.response.data.detail || error.response.data.message) || error?.response?.data?.detail?.[0]?.msg || error?.response?.data?.detail)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const updateExecutive = createAsyncThunk(
  'updateExecutive',
  async (body, thunkAPI) => {
    try {
      const updatedArray = (() => {
        const { user_name, first_name, last_name, password, email_id, role_id } = body;
      
        return {
          user_name,
          first_name,
          last_name,
          password,
          email_id,
          role_id
        };
      })();
      
      await ExecutivePortalService.updateExecutive(body.user_id ,updatedArray);
      const data = await ExecutivePortalService.teamManagementList();
      thunkAPI.dispatch(
        setMessage(
          "Successfully Updated Team Member Details"
        )
      );
      return { data };
    } catch (error) {
      
      const message =
        (
          error.response &&
          error.response.data &&
          ((error.response.data.detail || error.response.data.message) || error?.response?.data?.detail?.[0]?.msg)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const deleteExecutive = createAsyncThunk(
  'deleteExecutive',
  async (user_id, thunkAPI) => {
    try {
      await ExecutivePortalService.deleteExecutive(user_id);
      const data = await ExecutivePortalService.teamManagementList();
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const postTenantActivity = createAsyncThunk(
  'postTenantActivity',
  async (body, thunkAPI) => {
    try {
      const tenant_id = body?.tenant_id || ''
      const bodyVal = {
        activity_type:body?.activity_type || ''
      }
      
      
      const data = await ExecutivePortalService.postTenantActivity(tenant_id,bodyVal);
      
      return data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = {
  tenantAnalyticsData: null,
  tenantTrendsData:null,
  tenantManagementListData: null,
  teamManagementListData: null,
  postTenantActivityData:null
};

const executivePortalSlice = createSlice({
  name: 'executivePortal',
  initialState,
  reducers: {
    updateTeamManagementListData: (user_id) => {
      console.log('updateTeamManagementListData', user_id);
    },
    
    setPostTrendEmpty: (state, action) => {
      state.postTenantActivityData = null
    },
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(tenantAnalytics.fulfilled, (state, action) => {
        state.tenantAnalyticsData = action.payload;
      })
      .addCase(tenantAnalytics.rejected, (state, action) => {
        state.tenantAnalyticsData = null;
        console.log('rejected');
      })
      
      .addCase(tenantTrendsList.fulfilled, (state, action) => {
        state.tenantTrendsData = action.payload;
      })
      .addCase(tenantTrendsList.rejected, (state, action) => {
        state.tenantTrendsData = null;
        console.log('rejected');
      })
      .addCase(tenantManagementList.fulfilled, (state, action) => {
        state.tenantManagementListData = action.payload;
      })
      .addCase(tenantManagementList.rejected, (state, action) => {
        state.tenantManagementListData = null;
        console.log('rejected');
      })
      .addCase(teamManagementList.fulfilled, (state, action) => {
        state.teamManagementListData = action.payload;
      })
      .addCase(teamManagementList.rejected, (state, action) => {
        state.teamManagementListData = null;
        console.log('rejected');
      })
      .addCase(createTenant.fulfilled, (state, action) => {
        state.tenantManagementListData = action.payload;
        console.log('fulfilled');
      })
      .addCase(createTenant.rejected, (state, action) => {
        // state.teamManagementListData = null;
        console.log('rejected');
      })
      .addCase(deleteExecutive.fulfilled, (state, action) => {
        state.teamManagementListData = action.payload;
        console.log('User deleted successfully');
      })
      .addCase(deleteExecutive.rejected, (state, action) => {
        console.log('User deleted failed');
      })
      
      .addCase(postTenantActivity.fulfilled, (state, action) => {
        state.postTenantActivityData = action.payload;
        console.log('User Created successfully');
      })
      .addCase(postTenantActivity.rejected, (state, action) => {
      state.postTenantActivityData = null;
      })
      
      .addCase(updateExecutive.fulfilled, (state, action) => {
        // state.teamManagementListData = action.payload;
        console.log('User Updated successfully');
      })
      .addCase(updateExecutive.rejected, (state, action) => {
        console.log('User Updated failed');
      })
      .addCase(createExecutive.fulfilled, (state, action) => {
        state.teamManagementListData = action.payload;
        console.log('User Created successfully');
      })
      .addCase(createExecutive.rejected, (state, action) => {
        console.log('User Creation failed');
      })
      .addCase(deleteTenant.fulfilled, (state, action) => {
        state.tenantManagementListData = action.payload;
        console.log('Delete Tenant successfully');
      })
      .addCase(deleteTenant.rejected, (state, action) => {
        console.log('Delete Tenant failed');
      })
      .addCase(removeMobile.fulfilled, (state, action) => {
        state.tenantManagementListData = action.payload;
        console.log('Delete Tenant successfully');
      })
      .addCase(removeMobile.rejected, (state, action) => {
        console.log('Delete Tenant failed');
      });
      
  },
});

export const { updateTeamManagementListData ,setPostTrendEmpty} = executivePortalSlice.actions;

export default executivePortalSlice.reducer;